/* -------------------------------------------------------------------------------- *\
|                               hippodromes
\* -------------------------------------------------------------------------------- */
/**
 * Hippodrome (SIC) code ↔ display name.
 * Mirrors datas/hippodromes.csv at the repository root. The SIC code is the prefix
 * used in the archive file names (e.g. 20250829S-M7.tar.gz → S-M / Saint-Malo).
 * Keep this list in sync with datas/hippodromes.csv.
 */
export const HIPPODROMES: ReadonlyArray<[sic: string, name: string]> = [
    ['AIX', 'Aix-Les-Bains'],
    ['AMI', 'Amiens'],
    ['ANG', 'Angers'],
    ['ARG', 'Argentan'],
    ['ASC', 'Ascot'],
    ['AUT', 'Auteuil'],
    ['BEL', 'Belmont Park'],
    ['BOR', 'Marseille Borely'],
    ['BOU', 'Bordeaux Le Bouscat'],
    ['BRA', 'Nancy Brabois'],
    ['CAG', 'Cagnes-Sur-Mer'],
    ['CEP', 'Toulouse'],
    ['CHA', 'Chantilly'],
    ['CHB', 'Chateaubriant'],
    ['CHO', 'Cholet'],
    ['CLA', 'Clairefontaine'],
    ['COM', 'Compiegne'],
    ['CRA', 'Craon'],
    ['CRO', 'Le Croise-Laroche'],
    ['DAX', 'Dax'],
    ['DEA', 'Deauville'],
    ['DIE', 'Dieppe'],
    ['FON', 'Fontainebleau'],
    ['GLO', 'Gloucester Park'],
    ['LAT', 'Bordeaux La Teste'],
    ['LLA', "Le Lion-D'Angers"],
    ['LON', 'Paris Longchamp'],
    ['LSO', "Les Sables D'Olonne"],
    ['LYO', 'Lyon Parilly'],
    ['MAN', 'Le Mans'],
    ['MAR', 'Mont-De-Marsan'],
    ['MOU', 'Moulins'],
    ['PAU', 'Pau'],
    ['PET', 'Nantes'],
    ['PLB', 'Pornichet-La Baule'],
    ['PON', 'Marseille Vivaux'],
    ['SAI', 'Saint-Cloud'],
    ['SAL', 'Salon De Provence'],
    ['S-M', 'Saint-Malo'],
    ['STR', 'Strasbourg'],
    ['TAR', 'Tarbes'],
    ['VIC', 'Vichy'],
    ['VIL', 'Lyon La Soie'],
];

/** SIC code → display name (e.g. "S-M" → "Saint-Malo"). */
export const SIC_TO_NAME: ReadonlyMap<string, string> =
    new Map(HIPPODROMES.map(([sic, name]) => [sic, name]));

/** Set of known SIC codes, used to flag unrecognized codes coming from a CSV. */
export const KNOWN_SIC: ReadonlySet<string> = new Set(HIPPODROMES.map(([sic]) => sic));
